var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "a2305023976c0c9876cbb69f3ead521fedfc0db0"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["blog@pragmatic-pineapple"] = {
  id: "a2305023976c0c9876cbb69f3ead521fedfc0db0"
};